import { ComponentProps } from 'react';
import classNames from 'classnames';
import Typography from 'components/gruenland/atoms/typography';
import { TYPOGRAPHY_PAGE_TITLE, TYPOGRAPHY_PRIVATE_AREA_TITLE } from 'lib/typography';
import EditCTA from './edit-cta';
import InfoFields from './info-fields';

export type InfoField = { label: string; value: string };

interface InfoCardProps extends ComponentProps<'div'> {
  title: string;
  isEditable?: boolean;
  infoFields?: Array<InfoField>;
  cardClassName?: string;
  clearPadding?: boolean;
  editHref?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
  children,
  infoFields,
  className,
  cardClassName,
  title,
  isEditable,
  clearPadding,
  editHref,
}) => {
  const cardFullClassName = classNames(
    { 'flex items-start justify-between': !!isEditable },
    { 'py-6 px-4 md:px-6 md:pr-7 lg:pr-11': !clearPadding },
    'rounded-sm border border-neutral-400 md:mt-6',
    cardClassName,
  );

  return (
    <div className={className}>
      <Typography as="h3" className={TYPOGRAPHY_PRIVATE_AREA_TITLE}>
        {title}
      </Typography>

      <div className={cardFullClassName}>
        {children}

        {infoFields && <InfoFields fields={infoFields} />}

        {isEditable && editHref && <EditCTA editHref={editHref} />}
      </div>
    </div>
  );
};

export default InfoCard;
